// utils/userPermissions.js
export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin', 
  MANAGER: 'manager',
  VIEWER: 'viewer'
};

export const PERMISSIONS = {
  EDIT_USER_INFO: 'edit_user_info',
  EDIT_SECURITY: 'edit_security',
  DELETE_USER: 'delete_user',
  VIEW_SENSITIVE_DATA: 'view_sensitive_data',
  MANAGE_ROLES: 'manage_roles',
  BULK_OPERATIONS: 'bulk_operations'
};

export const ROLE_PERMISSIONS = {
  [USER_ROLES.SUPER_ADMIN]: [
    PERMISSIONS.EDIT_USER_INFO,
    PERMISSIONS.EDIT_SECURITY,
    PERMISSIONS.DELETE_USER,
    PERMISSIONS.VIEW_SENSITIVE_DATA,
    PERMISSIONS.MANAGE_ROLES,
    PERMISSIONS.BULK_OPERATIONS
  ],
  [USER_ROLES.ADMIN]: [
    PERMISSIONS.EDIT_USER_INFO,
    PERMISSIONS.DELETE_USER,
    PERMISSIONS.VIEW_SENSITIVE_DATA,
    PERMISSIONS.BULK_OPERATIONS
  ],
  [USER_ROLES.MANAGER]: [
    PERMISSIONS.EDIT_USER_INFO,
    PERMISSIONS.VIEW_SENSITIVE_DATA
  ],
  [USER_ROLES.VIEWER]: []
};

export const hasPermission = (userRole, permission) => {
  return ROLE_PERMISSIONS[userRole]?.includes(permission) || true;
};

export const canEditField = (userRole, fieldName) => {
  const sensitiveFields = ['password', 'role', 'status'];
  const basicFields = ['name', 'phone', 'address', 'restaurantName'];
  
  if (sensitiveFields.includes(fieldName)) {
    return hasPermission(userRole, PERMISSIONS.EDIT_SECURITY);
  }
  
  if (basicFields.includes(fieldName)) {
    return hasPermission(userRole, PERMISSIONS.EDIT_USER_INFO);
  }
  
  return true;
};
